import { cn } from '@anytag/shared-utils';
import { Icon } from '@anytag/shared-atoms';

interface ArrowProps {
  className?: string;
  to: string;
  onClick?: () => void;
}

export const LeftArrow = ({ className, to, onClick }: ArrowProps) => (
  <button type="button" aria-label={to} onClick={onClick} className={cn('button button--text button--icon', className)}>
    <Icon className={styles.icon} icon="arrow-left" size={20} variant="white" />
  </button>
);

export const RightArrow = ({ className, to, onClick }: ArrowProps) => (
  <button type="button" aria-label={to} onClick={onClick} className={cn('button button--text button--icon', className)}>
    <Icon className={styles.icon} icon="arrow-right" size={20} variant="white" />
  </button>
);
const styles = {
  button: cn('size-8 text-center'),
  icon: cn('drop-shadow-[0px_2px_4px_rgba(0,0,0,0.15)]')
};
